import TitleLetter from "./TitleLetter";
import * as THREE from "three";
import TitleTexture from "./TitleTexture";
import TitlePlayButton from "./TitlePlayButton";
import EventEmitter from "./EventEmitter";
import GlobalColorSingleton from "./GlobalColor";
import MobileDetector from "./MobileDetector";
import AudioEffects from "./AudioEffects";
import Utils from "./Utils";
import Config from "./Config";
export default class Title extends EventEmitter {
  constructor(width, height, scene, controls) {
    super();
    this.title = "xyztoy";
    this.width = width;
    this.height = height;
    this.scene = scene;
    this.controls = controls;
    // how mush we reduce the size of the letters
    this.scale_factor = 0.75;
    // this.load();
  }

  async load() {
    return new Promise(async (resolve, reject) => {
      const texture = new TitleTexture(`getRandomLetters/${this.title}`);
      this.textures = await texture.load();
      console.log("TEXTURE READY", this.textures);
      // get a first image for the color ?
      GlobalColorSingleton.setNewColors();
      setTimeout(() => {
        const size = this.calculateGridSizeByMaxChar(this.title.length);
        this.createLettersGrid(size);
        resolve();
      }, 10);
    });
  }
  calculateGridSizeByMaxChar(max) {
    const squareSize = this.getMaxSizeOfSquaresInRect(
      max,
      this.width,
      this.height
    );
    this.cols = 3; //Math.floor(this.width / squareSize);
    this.rows = 2; //Math.floor(this.height / squareSize);
    this.offsetX = (this.width - this.cols * squareSize) / 2;
    this.offsetY = (this.height - this.rows * squareSize) / 2;

    return squareSize;
  }

  createLettersGrid(size) {
    // get the vector from the camera to the target and normalize it
    const vector = new THREE.Vector3();
    vector.subVectors(this.controls.target, this.controls.object.position);
    vector.normalize();
    // get a point 10 units away from the camera
    const point = new THREE.Vector3();
    point.addVectors(this.controls.object.position, vector.multiplyScalar(10));

    this.group = new THREE.Group();
    this.group.position.set(point.x, point.y, point.z);
    this.group.lookAt(this.controls.object.position);
    this.scene.add(this.group);
    this.all_title_letters = [];
    let w = 0;
    for (let j = 0; j < this.rows; j++) {
      for (let i = 0; i < this.cols; i++) {
        // if (this.mesh.children.length >= this.title.length) break;
        const letter = new TitleLetter(
          Math.floor(size * this.scale_factor),
          this.textures
        );
        if (this.title[w]) {
          letter.updateTexture(this.title[w], 0);
          if (this.title[w] !== " ") this.all_title_letters.push(letter);
        }
        letter.position.set(
          this.offsetX - this.width / 2 + size / 2 + i * size,
          -this.offsetY + this.height / 2 - size / 2 - j * size,
          0
        );
        this.group.add(letter);

        if (letter.position.x + size > this.width) letter.visible = false;
        if (Math.abs(letter.position.y - size) > this.height)
          letter.visible = false;
        w++;
      }
    }
    if (MobileDetector.isMobile)
      this.ROLL_INTERVAL = setInterval(this.rolling.bind(this), 1500);

    // add a button, in the center of the screen
    this.addPlayButton(size);
  }

  addPlayButton(size) {
    // this.playButton = new TitlePlayButton(size * this.scale_factor);
    // this.group.add(this.playButton);
    // convert to real pixels screen dimensions

    // get dimensions of camera
    const camera = this.controls.object;
    const width = camera.right - camera.left;
    // get ratio from screen to camera
    const ratio = window.innerWidth / width;
    // get the real size of the button
    const realSizeX = size * this.scale_factor * ratio;
    let factor = MobileDetector.isMobile ? 2 : 1;

    // const realSizeY = size * this.scale_factor * ratio * 0.25;

    // create div
    const wrapper = document.createElement("div");
    wrapper.className = "wrapper-button";
    this.playButton = document.createElement("div");
    this.playButton.className = "play-button";
    // 268
    this.playButton.style.width = "302px"; //`${Math.max(realSizeX * factor, 302)}px`;
    // this.playButton.textContent = "Can you guess the hidden word ?";
    this.playButton.textContent = Utils.translate(
      "Slogan_1",
      Config.dictionary
    );
    wrapper.appendChild(this.playButton);
    document.body.appendChild(wrapper);
    this.playButton.addEventListener("click", (e) => {
      // AudioEffects.resume();
      AudioEffects.playRandom(120);
      this.emit("click", []);
      this.playButton.classList.add("deactivate");
    });
    // arrow sign
    const arrow = document.createElement("span");
    arrow.classList.add("material-icons");
    arrow.textContent = "play_arrow";
    this.playButton.appendChild(arrow);
  }

  showPlayButton() {
    // this.playButton.visible = true;
    this.playButton.classList.add("show");
  }

  resize(width, height) {
    if (!this.group) return;
    this.width = width;
    this.height = height;

    const size = this.calculateGridSizeByMaxChar(this.title.length);
    // remove mesh children
    this.group.children.forEach((child, i) => {
      console.log(child.name);
      if (child.name != "playbutton") {
        child.updateGeometry(Math.floor(size * this.scale_factor));
        // get x and y values
        const x = i % this.cols;
        const y = Math.floor(i / this.cols);
        child.position.set(
          this.offsetX - this.width / 2 + size / 2 + x * size,
          -this.offsetY + this.height / 2 - size / 2 - y * size,
          0
        );
        child.visible = true;
        // console.log(child.position, this.height, size);
        if (child.position.x + size > this.width) child.visible = false;
        if (Math.abs(child.position.y) > this.height / 2) child.visible = false;
      } else {
        console.log("play button detected");
      }
    });
    // update play button
    // this.playButton.updateGeometry(Math.floor(size * this.scale_factor));
    // update the html button
    // get dimensions of camera
    const camera = this.controls.object;
    const _width = camera.right - camera.left;
    // get ratio from screen to camera
    const ratio = window.innerWidth / _width;
    console.log("ratio", ratio);
    // get the real size of the button
    const realSizeX = size * this.scale_factor * ratio;
    let factor = MobileDetector.isMobile ? 2 : 1;
    // update div
    const div = document.querySelector(".play-button");
    div.style.width = `${Math.max(realSizeX * factor, 268)}px`;
  }

  update() {
    if (!this.group) return;
    // get the vector from the camera to the target and normalize it
    const vector = new THREE.Vector3();
    vector.subVectors(this.controls.target, this.controls.object.position);
    vector.normalize();
    // get a point 100 units away from the camera
    const point = new THREE.Vector3();
    point.addVectors(this.controls.object.position, vector.multiplyScalar(10));
    this.group.position.set(point.x, point.y, point.z);
    this.group.lookAt(this.controls.object.position);
  }

  getMaxSizeOfSquaresInRect(n, w, h) {
    let sw = 0;
    let sh = 0;
    let pw = Math.ceil(Math.sqrt((n * w) / h));
    if (Math.floor((pw * h) / w) * pw < n) sw = h / Math.ceil((pw * h) / w);
    else sw = w / pw;
    let ph = Math.ceil(Math.sqrt((n * h) / w));
    if (Math.floor((ph * w) / h) * ph < n) sh = w / Math.ceil((w * ph) / h);
    else sh = h / ph;
    return Math.max(sw, sh);
  }

  rolling() {
    const newRollingLetter = Math.floor(
      Math.random() * this.all_title_letters.length
    );
    if (newRollingLetter == this.previousRollingLetter) {
      this.rolling();
      return;
    }
    this.previousRollingLetter = newRollingLetter;
    this.all_title_letters[newRollingLetter].roll();
  }

  hide() {
    // stop interval
    clearInterval(this.ROLL_INTERVAL);
    // hide all letters
    this.all_title_letters.forEach((letter, index) => {
      setTimeout(() => {
        letter.hide();
      }, index * 100);
    });
    // hide play button
    // this.playButton.hide();
    this.playButton.classList.add("zoomOut");
    // kill all geometries
    setTimeout(() => {
      this.kill();
    }, 2600);
  }

  kill() {
    this.group.children.forEach((child, i) => {
      child.cube.geometry.dispose();
      // child.cube.material.dispose();
      child.geometry.dispose();
    });
    this.scene.remove(this.group);
    this.group = null;
    this.emit("removed", []);
  }
}
